import { IInvitation } from "@/shared/api/invitations"
import { ColumnDef } from "@tanstack/react-table"
import { Table } from "@/shared/ui/table"
import { Loader } from "@/shared/ui/loader"
import { NoTableData } from "@/shared/ui/no-table-data"
import { API_URL } from "@/shared/api/base"
import { DropdownButton } from "@/shared/ui/dropdown-button"
import { DeleteInvitation } from "../delete-invitation"
import { InspectInvitation } from "../inspect-invitation"
import { FC } from "react"

interface InvitationsTableProps {
    invitations: IInvitation[]
    isLoading: boolean
    onDelete: () => void
}

export const InvitationsTable: FC<InvitationsTableProps> = ({ onDelete, invitations, isLoading }) => {
    const columns: ColumnDef<IInvitation, any>[] = [
        {
            accessorFn: (invitation) => (
                <div className="w-full">
                    {invitation.type === 'link'
                        ? API_URL + `invitations/redirect/${invitation.link}`
                        : <div className="w-full flex justify-center">
                            <img src={invitation.link} alt="" className="w-16 h-16" />
                        </div>
                    }
                </div>
            ),
            enableSorting: false,
            id: 'link',
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Ссылка</div>,
        },
        {
            accessorFn: (invitation) => (
                <div className="w-full">
                    {invitation.group.name}
                </div>
            ),
            id: 'group',
            enableSorting: false,
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Группа</div>,
        },
        {
            accessorFn: (invitation) => (
                <div className="w-full">
                    {invitation.total_redirects}
                </div>
            ),
            enableSorting: false,
            id: 'totalRedirects',
            cell: info => info.getValue(),
            header: () => <div className="!text-start text-nowrap">Количество переходов</div>,
        },
        {
            accessorFn: (invitation) => (
                <div className="w-full flex justify-end">
                <DropdownButton>
                    {invitation.type === 'qr' &&
                        <InspectInvitation invitation={invitation}/>
                    }
                    <DeleteInvitation onDelete={onDelete} invitation={invitation}/>
                </DropdownButton>
            </div>
            ),
            enableSorting: false,
            id: 'actions',
            cell: info => info.getValue(),
            header: () => <div/>,
        },
    ]

    return (
        <>
            {Boolean(invitations.length) &&
                <div className="table_box">
                    <Table columns={columns} data={invitations} />
                </div>
            }
            {(!Boolean(invitations.length) && isLoading) &&
                <div className="info_panel">
                    <Loader />
                </div>
            }
            {(!Boolean(invitations.length) && !isLoading) &&
                <NoTableData label="Нет данных о приглашениях" />
            }
        </>
    )
}